import type { IntlShape } from 'react-intl';
import { ApiError } from '../api/client';

export function authErrorMessage(intl: IntlShape, error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === 'locked') {
      const seconds = Number(error.details.retryAfter ?? 900);
      return intl.formatMessage(
        { id: 'auth.error.locked' },
        { minutes: Math.max(1, Math.ceil(seconds / 60)) },
      );
    }
    const known = [
      'invalid_credentials',
      'invalid_code',
      'rate_limited',
      'weak_password',
      'breached_password',
      'password_reused',
      'csrf',
    ];
    if (known.includes(error.code)) {
      if (error.code === 'weak_password') {
        return intl.formatMessage({
          id: `auth.error.weak_password.${String(error.details.reason ?? 'too_short')}`,
        });
      }
      return intl.formatMessage({ id: `auth.error.${error.code}` });
    }
    if (error.status === 401) return intl.formatMessage({ id: 'auth.error.session_expired' });
  }
  return intl.formatMessage({ id: 'auth.error.generic' });
}
